<fa-icon [icon]="loadingIcon" class="text-2xl animate-spin"></fa-icon>
<div *ngIf="text" class="text-white">{{text}}</div>
